module.exports = __webpack_public_path__ + "img/selbsterfahrung_640.b22987cb.png";